import React from 'react';
import SavingsShowcase from '../components/SavingsShowcase';
import Explore from '../components/Explore';
import Features from '../components/Features';

const Services = () => {
    return (
        <div>
            <Explore />
            <Features />
            <h2 className="text-heading center">Earn profit on your savings</h2>
            <SavingsShowcase />
        </div>
    );
}

export default Services;
